/**
 * @flow
 * @relayHash 7d925c15286097855beaa81f9a96f967
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateShowcaseAssetInput = {|
  assetId: string,
  fileName?: ?string,
  description?: ?string,
  clientMutationId?: ?string,
|};
export type UpdateShowcaseAssetMutationVariables = {|
  input: UpdateShowcaseAssetInput
|};
export type UpdateShowcaseAssetMutationResponse = {|
  +updateShowcaseAsset: ?{|
    +asset: ?{|
      +id: string
    |}
  |}
|};
export type UpdateShowcaseAssetMutation = {|
  variables: UpdateShowcaseAssetMutationVariables,
  response: UpdateShowcaseAssetMutationResponse,
|};
*/


/*
mutation UpdateShowcaseAssetMutation(
  $input: UpdateShowcaseAssetInput!
) {
  updateShowcaseAsset(input: $input) {
    asset {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateShowcaseAssetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateShowcaseAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateShowcaseAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "asset",
        "storageKey": null,
        "args": null,
        "concreteType": "AssetNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateShowcaseAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateShowcaseAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateShowcaseAssetMutation",
    "id": null,
    "text": "mutation UpdateShowcaseAssetMutation(\n  $input: UpdateShowcaseAssetInput!\n) {\n  updateShowcaseAsset(input: $input) {\n    asset {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '34fdfacfb8396b265838d670e6e33bf5';
module.exports = node;
